const ERROR_UNKNOWN = 'UNKNOWN' as const;
const ERROR_NOT_FOUND = 'NOT_FOUND' as const;
const ERROR_TO_FILTER = 'TO_FILTER' as const;

export { ERROR_UNKNOWN, ERROR_NOT_FOUND, ERROR_TO_FILTER };
